import PropertyViewData, { IPropertyViewData } from "../property/PropertyViewData";
import GradeCalculatedData, { IGradeCalculatedData } from "../grade/GradeCalculatedData";

export interface ICalculatedPropertyData {
    property: IPropertyViewData,
    target: any,
    sigma: any,
    gain: any,
    offset: any,
    minValue: any,
    maxValue: any,
    alarmLow1: any,
    alarmHigh1: any,
    alarmLow2: any,
    alarmHigh2: any,
    rejectLow: any,
    rejectHigh: any,
    sourceMappings: IGradeCalculatedData[],
    formulaMappings?: any[],
    order?: any,
    sigmaPercent?: boolean
}

export default class CalculatedPropertyData implements ICalculatedPropertyData {
    property: IPropertyViewData;
    target: any;
    sigma: any;
    gain: any;
    offset: any;
    minValue: any;
    maxValue: any;
    alarmLow1: any;
    alarmHigh1: any;
    alarmLow2: any;
    alarmHigh2: any;
    rejectLow: any;
    rejectHigh: any;
    sourceMappings: IGradeCalculatedData[];
    formulaMappings?: any[];
    order?: any;
    sigmaPercent?: boolean;

    constructor(property: IPropertyViewData, target: any,
        sigma: any,
        gain: any,
        offset: any,
        minValue: any,
        maxValue: any,
        alarmLow1: any,
        alarmHigh1: any,
        alarmLow2: any,
        alarmHigh2: any,
        rejectLow: any,
        rejectHigh: any, sourceMappings: IGradeCalculatedData[],
        formulaMappings?: any[],
        order?: any,
        sigmaPercent?: boolean
    ) {
        this.property = property;
        this.target = target;
        this.sigma = sigma;
        this.gain = gain;
        this.offset = offset;
        this.minValue = minValue;
        this.maxValue = maxValue;
        this.alarmLow1 = alarmLow1;
        this.alarmHigh1 = alarmHigh1;
        this.alarmLow2 = alarmLow2;
        this.alarmHigh2 = alarmHigh2;
        this.rejectLow = rejectLow;
        this.rejectHigh = rejectHigh;
        this.sourceMappings = sourceMappings ? sourceMappings : [];
        this.formulaMappings = formulaMappings;
        this.order = order;
        this.sigmaPercent = sigmaPercent;
    }
}

const defaultCalculatedPropertiesData = new CalculatedPropertyData(new PropertyViewData("", "", "", 0, "", "", "", 0), "", "", "", "", "", "", "", "", "", "", "", "", []);
export { defaultCalculatedPropertiesData };
